import SearchFilter from 'store/models/SearchFilter';
import { Statuses, StatusI } from 'store/models/Statuses';
import { TicketType } from 'store/models/TicketTypeHelper';
import {
  EachSortBy,
  SortDirType,
} from 'store/models/workdesk-tickets/workdesk-tickets.interface';
export interface WorkdeskFilterStoreState {
  selectedInboxes: { [address: string]: boolean };
  selectedStatus: StatusI;
  selectedTicketType: TicketType;
  sortBy: EachSortBy[];
  searchValues: object;
  statusesStartAt: {
    [status: string]: { [ticketType: string]: number };
  };
  workdeskFilterInLsOnInit?: boolean;
}

export interface WorkdeskFilterWithPrevStoreState {
  cur: WorkdeskFilterStoreState;
  prev: WorkdeskFilterStoreState | null;
  hadCalledApi: boolean;
  beforeLoadMainPageSelectedInboxes: { [address: string]: boolean };
}

export class WorkdeskFilter {
  static key = 'workdeskFilter';
  static hasValueInSessionStorage() {
    return !!WorkdeskFilter.getFromLocalStorage();
  }
  static saveToLocalStorage(value: WorkdeskFilterStoreState) {
    value = {
      ...value,
      statusesStartAt: {},
      workdeskFilterInLsOnInit: false,
    };
    localStorage.setItem(WorkdeskFilter.key, JSON.stringify(value));
  }
  static getFromLocalStorage() {
    const v = localStorage.getItem(WorkdeskFilter.key);
    // TODO: validate value
    // if selected is all change to SI // TODO: make sure it follows what it is supposed to be per status
    let parsed = v && JSON.parse(v);

    // convert historical data
    // remove selectedStatusType and replace with selectedTicketType
    if (parsed && parsed.selectedStatusType !== undefined) {
      const { selectedStatusType, ...others } = parsed;
      parsed = { ...others, selectedTicketType: selectedStatusType };
    }
    if (parsed && parsed.selectedTicketType === 'ALL') {
      parsed.selectedTicketType = Statuses.defaultTicketType;
    }

    // old version of statusesStartAt -> clear
    if (parsed && parsed.statusesStartAt) {
      if (
        Object.values(parsed.statusesStartAt).some(
          (v) => typeof v === 'number',
        )
      ) {
        parsed.statusesStartAt = {};
      }
    }

    // console.debug(`getFromLocalStorage: `, parsed);

    return parsed;
  }

  static clearFromLocalStorage() {
    localStorage.removeItem(WorkdeskFilter.key);
  }

  wdFilter;
  constructor(wdFilter: WorkdeskFilterStoreState) {
    this.wdFilter = wdFilter;
  }

  hasAnySearchValues() {
    return SearchFilter.hasAnySearchValues(
      this.wdFilter.searchValues,
    );
  }
}

class WorkdeskFilterSortBy {
  sortBy: EachSortBy[];
  returnModel: boolean;
  constructor(sortBy: EachSortBy[], returnModel = false) {
    this.sortBy = sortBy;
    this.returnModel = returnModel;
  }
  getSortDirOfField(field: string): SortDirType {
    const item = this.sortBy.find((each) => each.field === field);
    if (!item) throw Error(`couldn't find ${field} in sortBy`);
    return item && item.dir;
  }
  getSortDirAndIndexOfField(field: string) {
    const itemI = this.sortBy.findIndex(
      (each) => each.field === field,
    );
    if (itemI < 0) return null;
    return {
      index: itemI,
      dir: this.sortBy[itemI].dir,
    };
  }
  getSortDirAndRankOfField(field: string) {
    const res = this.getSortDirAndIndexOfField(field);
    if (!res) return res;
    const { index, dir } = res;
    return {
      rank: index + 1,
      dir,
    };
  }
  static getTheOppositeSortDir(dir: SortDirType) {
    switch (dir) {
      case 'DESC':
        return 'ASC';
      case 'ASC':
        return 'DESC';
      default:
        throw Error(`invlaid sort dir ${dir}`);
    }
  }

  /**
   * single sort version
   * @param field
   */
  singleSortToggleSortDirOfField(field: string, dir: SortDirType) {
    // version multiple sort
    this.sortBy = [
      {
        field,
        dir,
      },
    ];
    return this.returnModel ? this : this.sortBy;
  }
}

export { WorkdeskFilterSortBy };
